// extracted by mini-css-extract-plugin
module.exports = {"pillWrapper":"GkovclH","pill":"_3wY6tfM"};